import { useQuery } from '@tanstack/react-query';
import { getImportExportStatus } from 'Services';
import { GET_IMPORT_EXPORT_STATUS_FREQUENCY, RQ_GET_LIST_IMPORT_EXPORT_STATUS } from 'Utils';
import { useSelector } from 'react-redux';
import { getSidePanelIsOpen } from 'Selectors';

const useGetImportExportStatus = () => {
    const isOpen = useSelector(getSidePanelIsOpen);
    return useQuery([RQ_GET_LIST_IMPORT_EXPORT_STATUS], () => getImportExportStatus(), {
        enabled: isOpen,
        refetchInterval: GET_IMPORT_EXPORT_STATUS_FREQUENCY,
        keepPreviousData: true
    });
};

export default useGetImportExportStatus;
